import { connect } from 'react-redux'

import {
  fetchCards,
  fetchRentalHistory,
} from 'app/bond_cover/bond_cover_actions'
import ProfileAccount from 'app/session/bc_profile/profile_account_container'
import {
  addRentalReputationBackUrl,
  clearRentalBackUrl,
  setBackUrl,
} from 'app/shared_components/actions'

const mapStateToProps = ({
  session,
  bondCover,
}: {
  session: any
  bondCover: any
}) => ({
  currentUser: session.currentUser,
  rentalHistory: bondCover.rentalHistory,
  paymentOptions: bondCover.paymentOptions,
})

const mapDispatchToProps = (dispatch: any) => ({
  fetchRentalHistory: () => dispatch(fetchRentalHistory()),
  fetchCards: () => fetchCards(),
  setBackUrl: (url: any) => dispatch(setBackUrl(url)),
  addRentalReputationBackUrl: (url: any) =>
    dispatch(addRentalReputationBackUrl(url)),
  clearRentalBackUrl: () => dispatch(clearRentalBackUrl()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAccount)
